import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';

import afLocale from "react-intl/locale-data/af";
import agqLocale from "react-intl/locale-data/agq";
import akLocale from "react-intl/locale-data/ak";
import amLocale from "react-intl/locale-data/am";
import arLocale from "react-intl/locale-data/ar";
import arsLocale from "react-intl/locale-data/ars";
import asLocale from "react-intl/locale-data/as";
import asaLocale from "react-intl/locale-data/asa";
import astLocale from "react-intl/locale-data/ast";
import azLocale from "react-intl/locale-data/az";
import basLocale from "react-intl/locale-data/bas";
import beLocale from "react-intl/locale-data/be";
import bemLocale from "react-intl/locale-data/bem";
import bezLocale from "react-intl/locale-data/bez";
import bgLocale from "react-intl/locale-data/bg";
import bhLocale from "react-intl/locale-data/bh";
import bmLocale from "react-intl/locale-data/bm";
import bnLocale from "react-intl/locale-data/bn";
import boLocale from "react-intl/locale-data/bo";
import brLocale from "react-intl/locale-data/br";
import brxLocale from "react-intl/locale-data/brx";
import bsLocale from "react-intl/locale-data/bs";
import caLocale from "react-intl/locale-data/ca";
import ceLocale from "react-intl/locale-data/ce";
import cggLocale from "react-intl/locale-data/cgg";
import chrLocale from "react-intl/locale-data/chr";
import ckbLocale from "react-intl/locale-data/ckb";
import csLocale from "react-intl/locale-data/cs";
import cuLocale from "react-intl/locale-data/cu";
import cyLocale from "react-intl/locale-data/cy";
import daLocale from "react-intl/locale-data/da";
import davLocale from "react-intl/locale-data/dav";
import deLocale from "react-intl/locale-data/de";
import djeLocale from "react-intl/locale-data/dje";
import dsbLocale from "react-intl/locale-data/dsb";
import duaLocale from "react-intl/locale-data/dua";
import dvLocale from "react-intl/locale-data/dv";
import dyoLocale from "react-intl/locale-data/dyo";
import dzLocale from "react-intl/locale-data/dz";
import ebuLocale from "react-intl/locale-data/ebu";
import eeLocale from "react-intl/locale-data/ee";
import elLocale from "react-intl/locale-data/el";
import enLocale from "react-intl/locale-data/en";
import eoLocale from "react-intl/locale-data/eo";
import esLocale from "react-intl/locale-data/es";
import etLocale from "react-intl/locale-data/et";
import euLocale from "react-intl/locale-data/eu";
import ewoLocale from "react-intl/locale-data/ewo";
import faLocale from "react-intl/locale-data/fa";
import ffLocale from "react-intl/locale-data/ff";
import fiLocale from "react-intl/locale-data/fi";
import filLocale from "react-intl/locale-data/fil";
import foLocale from "react-intl/locale-data/fo";
import frLocale from "react-intl/locale-data/fr";
import furLocale from "react-intl/locale-data/fur";
import fyLocale from "react-intl/locale-data/fy";
import gaLocale from "react-intl/locale-data/ga";
import gdLocale from "react-intl/locale-data/gd";
import glLocale from "react-intl/locale-data/gl";
import gswLocale from "react-intl/locale-data/gsw";
import guLocale from "react-intl/locale-data/gu";
import guwLocale from "react-intl/locale-data/guw";
import guzLocale from "react-intl/locale-data/guz";
import gvLocale from "react-intl/locale-data/gv";
import haLocale from "react-intl/locale-data/ha";
import hawLocale from "react-intl/locale-data/haw";
import heLocale from "react-intl/locale-data/he";
import hiLocale from "react-intl/locale-data/hi";
import hrLocale from "react-intl/locale-data/hr";
import hsbLocale from "react-intl/locale-data/hsb";
import huLocale from "react-intl/locale-data/hu";
import hyLocale from "react-intl/locale-data/hy";
import idLocale from "react-intl/locale-data/id";
import igLocale from "react-intl/locale-data/ig";
import iiLocale from "react-intl/locale-data/ii";
import inLocale from "react-intl/locale-data/in";
import isLocale from "react-intl/locale-data/is";
import itLocale from "react-intl/locale-data/it";
import iuLocale from "react-intl/locale-data/iu";
import iwLocale from "react-intl/locale-data/iw";
import jaLocale from "react-intl/locale-data/ja";
import jboLocale from "react-intl/locale-data/jbo";
import jgoLocale from "react-intl/locale-data/jgo";
import jiLocale from "react-intl/locale-data/ji";
import jmcLocale from "react-intl/locale-data/jmc";
import jvLocale from "react-intl/locale-data/jv";
import jwLocale from "react-intl/locale-data/jw";
import kaLocale from "react-intl/locale-data/ka";
import kabLocale from "react-intl/locale-data/kab";
import kajLocale from "react-intl/locale-data/kaj";
import kamLocale from "react-intl/locale-data/kam";
import kcgLocale from "react-intl/locale-data/kcg";
import kdeLocale from "react-intl/locale-data/kde";
import keaLocale from "react-intl/locale-data/kea";
import khqLocale from "react-intl/locale-data/khq";
import kiLocale from "react-intl/locale-data/ki";
import kkLocale from "react-intl/locale-data/kk";
import kkjLocale from "react-intl/locale-data/kkj";
import klLocale from "react-intl/locale-data/kl";
import klnLocale from "react-intl/locale-data/kln";
import kmLocale from "react-intl/locale-data/km";
import knLocale from "react-intl/locale-data/kn";
import koLocale from "react-intl/locale-data/ko";
import kokLocale from "react-intl/locale-data/kok";
import ksLocale from "react-intl/locale-data/ks";
import ksbLocale from "react-intl/locale-data/ksb";
import ksfLocale from "react-intl/locale-data/ksf";
import kshLocale from "react-intl/locale-data/ksh";
import kuLocale from "react-intl/locale-data/ku";
import kwLocale from "react-intl/locale-data/kw";
import kyLocale from "react-intl/locale-data/ky";
import lagLocale from "react-intl/locale-data/lag";
import lbLocale from "react-intl/locale-data/lb";
import lgLocale from "react-intl/locale-data/lg";
import lktLocale from "react-intl/locale-data/lkt";
import lnLocale from "react-intl/locale-data/ln";
import loLocale from "react-intl/locale-data/lo";
import lrcLocale from "react-intl/locale-data/lrc";
import ltLocale from "react-intl/locale-data/lt";
import luLocale from "react-intl/locale-data/lu";
import luoLocale from "react-intl/locale-data/luo";
import luyLocale from "react-intl/locale-data/luy";
import lvLocale from "react-intl/locale-data/lv";
import masLocale from "react-intl/locale-data/mas";
import merLocale from "react-intl/locale-data/mer";
import mfeLocale from "react-intl/locale-data/mfe";
import mgLocale from "react-intl/locale-data/mg";
import mghLocale from "react-intl/locale-data/mgh";
import mgoLocale from "react-intl/locale-data/mgo";
import mkLocale from "react-intl/locale-data/mk";
import mlLocale from "react-intl/locale-data/ml";
import mnLocale from "react-intl/locale-data/mn";
import moLocale from "react-intl/locale-data/mo";
import mrLocale from "react-intl/locale-data/mr";
import msLocale from "react-intl/locale-data/ms";
import mtLocale from "react-intl/locale-data/mt";
import muaLocale from "react-intl/locale-data/mua";
import myLocale from "react-intl/locale-data/my";
import mznLocale from "react-intl/locale-data/mzn";
import nahLocale from "react-intl/locale-data/nah";
import naqLocale from "react-intl/locale-data/naq";
import nbLocale from "react-intl/locale-data/nb";
import ndLocale from "react-intl/locale-data/nd";
import ndsLocale from "react-intl/locale-data/nds";
import neLocale from "react-intl/locale-data/ne";
import nlLocale from "react-intl/locale-data/nl";
import nmgLocale from "react-intl/locale-data/nmg";
import nnLocale from "react-intl/locale-data/nn";
import nnhLocale from "react-intl/locale-data/nnh";
import noLocale from "react-intl/locale-data/no";
import nqoLocale from "react-intl/locale-data/nqo";
import nrLocale from "react-intl/locale-data/nr";
import nsoLocale from "react-intl/locale-data/nso";
import nusLocale from "react-intl/locale-data/nus";
import nyLocale from "react-intl/locale-data/ny";
import nynLocale from "react-intl/locale-data/nyn";
import omLocale from "react-intl/locale-data/om";
import orLocale from "react-intl/locale-data/or";
import osLocale from "react-intl/locale-data/os";
import paLocale from "react-intl/locale-data/pa";
import papLocale from "react-intl/locale-data/pap";
import plLocale from "react-intl/locale-data/pl";
import prgLocale from "react-intl/locale-data/prg";
import psLocale from "react-intl/locale-data/ps";
import ptLocale from "react-intl/locale-data/pt";
import quLocale from "react-intl/locale-data/qu";
import rmLocale from "react-intl/locale-data/rm";
import rnLocale from "react-intl/locale-data/rn";
import roLocale from "react-intl/locale-data/ro";
import rofLocale from "react-intl/locale-data/rof";
import ruLocale from "react-intl/locale-data/ru";
import rwLocale from "react-intl/locale-data/rw";
import rwkLocale from "react-intl/locale-data/rwk";
import sahLocale from "react-intl/locale-data/sah";
import saqLocale from "react-intl/locale-data/saq";
import sbpLocale from "react-intl/locale-data/sbp";
import sdhLocale from "react-intl/locale-data/sdh";
import seLocale from "react-intl/locale-data/se";
import sehLocale from "react-intl/locale-data/seh";
import sesLocale from "react-intl/locale-data/ses";
import sgLocale from "react-intl/locale-data/sg";
import shLocale from "react-intl/locale-data/sh";
import shiLocale from "react-intl/locale-data/shi";
import siLocale from "react-intl/locale-data/si";
import skLocale from "react-intl/locale-data/sk";
import slLocale from "react-intl/locale-data/sl";
import smaLocale from "react-intl/locale-data/sma";
import smiLocale from "react-intl/locale-data/smi";
import smjLocale from "react-intl/locale-data/smj";
import smnLocale from "react-intl/locale-data/smn";
import smsLocale from "react-intl/locale-data/sms";
import snLocale from "react-intl/locale-data/sn";
import soLocale from "react-intl/locale-data/so";
import sqLocale from "react-intl/locale-data/sq";
import srLocale from "react-intl/locale-data/sr";
import ssLocale from "react-intl/locale-data/ss";
import ssyLocale from "react-intl/locale-data/ssy";
import stLocale from "react-intl/locale-data/st";
import svLocale from "react-intl/locale-data/sv";
import swLocale from "react-intl/locale-data/sw";
import syrLocale from "react-intl/locale-data/syr";
import taLocale from "react-intl/locale-data/ta";
import teLocale from "react-intl/locale-data/te";
import teoLocale from "react-intl/locale-data/teo";
import thLocale from "react-intl/locale-data/th";
import tiLocale from "react-intl/locale-data/ti";
import tigLocale from "react-intl/locale-data/tig";
import tkLocale from "react-intl/locale-data/tk";
import tlLocale from "react-intl/locale-data/tl";
import tnLocale from "react-intl/locale-data/tn";
import toLocale from "react-intl/locale-data/to";
import trLocale from "react-intl/locale-data/tr";
import tsLocale from "react-intl/locale-data/ts";
import twqLocale from "react-intl/locale-data/twq";
import tzmLocale from "react-intl/locale-data/tzm";
import ugLocale from "react-intl/locale-data/ug";
import ukLocale from "react-intl/locale-data/uk";
import urLocale from "react-intl/locale-data/ur";
import uzLocale from "react-intl/locale-data/uz";
import vaiLocale from "react-intl/locale-data/vai";
import veLocale from "react-intl/locale-data/ve";
import viLocale from "react-intl/locale-data/vi";
import voLocale from "react-intl/locale-data/vo";
import vunLocale from "react-intl/locale-data/vun";
import waLocale from "react-intl/locale-data/wa";
import waeLocale from "react-intl/locale-data/wae";
import woLocale from "react-intl/locale-data/wo";
import xhLocale from "react-intl/locale-data/xh";
import xogLocale from "react-intl/locale-data/xog";
import yavLocale from "react-intl/locale-data/yav";
import yiLocale from "react-intl/locale-data/yi";
import yoLocale from "react-intl/locale-data/yo";
import yueLocale from "react-intl/locale-data/yue";
import zghLocale from "react-intl/locale-data/zgh";
import zhLocale from "react-intl/locale-data/zh";
import zuLocale from "react-intl/locale-data/zu";

import { load, loadLocales } from "../../actions/i18n";
import Loading from '../../views/_Lessons/Notes/Loading';

/*
https://github.com/formatjs/react-intl/blob/master/docs/API.md
type MessageDescriptor = {
  id: string,
  defaultMessage?: string,
  description?: string | object,
};
*/

addLocaleData([
  ...afLocale,
  ...agqLocale,
  ...akLocale,
  ...amLocale,
  ...arLocale,
  ...arsLocale,
  ...asLocale,
  ...asaLocale,
  ...astLocale,
  ...azLocale,
  ...basLocale,
  ...beLocale,
  ...bemLocale,
  ...bezLocale,
  ...bgLocale,
  ...bhLocale,
  ...bmLocale,
  ...bnLocale,
  ...boLocale,
  ...brLocale,
  ...brxLocale,
  ...bsLocale,
  ...caLocale,
  ...ceLocale,
  ...cggLocale,
  ...chrLocale,
  ...ckbLocale,
  ...csLocale,
  ...cuLocale,
  ...cyLocale,
  ...daLocale,
  ...davLocale,
  ...deLocale,
  ...djeLocale,
  ...dsbLocale,
  ...duaLocale,
  ...dvLocale,
  ...dyoLocale,
  ...dzLocale,
  ...ebuLocale,
  ...eeLocale,
  ...elLocale,
  ...enLocale,
  ...eoLocale,
  ...esLocale,
  ...etLocale,
  ...euLocale,
  ...ewoLocale,
  ...faLocale,
  ...ffLocale,
  ...fiLocale,
  ...filLocale,
  ...foLocale,
  ...frLocale,
  ...furLocale,
  ...fyLocale,
  ...gaLocale,
  ...gdLocale,
  ...glLocale,
  ...gswLocale,
  ...guLocale,
  ...guwLocale,
  ...guzLocale,
  ...gvLocale,
  ...haLocale,
  ...hawLocale,
  ...heLocale,
  ...hiLocale,
  ...hrLocale,
  ...hsbLocale,
  ...huLocale,
  ...hyLocale,
  ...idLocale,
  ...igLocale,
  ...iiLocale,
  ...inLocale,
  ...isLocale,
  ...itLocale,
  ...iuLocale,
  ...iwLocale,
  ...jaLocale,
  ...jboLocale,
  ...jgoLocale,
  ...jiLocale,
  ...jmcLocale,
  ...jvLocale,
  ...jwLocale,
  ...kaLocale,
  ...kabLocale,
  ...kajLocale,
  ...kamLocale,
  ...kcgLocale,
  ...kdeLocale,
  ...keaLocale,
  ...khqLocale,
  ...kiLocale,
  ...kkLocale,
  ...kkjLocale,
  ...klLocale,
  ...klnLocale,
  ...kmLocale,
  ...knLocale,
  ...koLocale,
  ...kokLocale,
  ...ksLocale,
  ...ksbLocale,
  ...ksfLocale,
  ...kshLocale,
  ...kuLocale,
  ...kwLocale,
  ...kyLocale,
  ...lagLocale,
  ...lbLocale,
  ...lgLocale,
  ...lktLocale,
  ...lnLocale,
  ...loLocale,
  ...lrcLocale,
  ...ltLocale,
  ...luLocale,
  ...luoLocale,
  ...luyLocale,
  ...lvLocale,
  ...masLocale,
  ...merLocale,
  ...mfeLocale,
  ...mgLocale,
  ...mghLocale,
  ...mgoLocale,
  ...mkLocale,
  ...mlLocale,
  ...mnLocale,
  ...moLocale,
  ...mrLocale,
  ...msLocale,
  ...mtLocale,
  ...muaLocale,
  ...myLocale,
  ...mznLocale,
  ...nahLocale,
  ...naqLocale,
  ...nbLocale,
  ...ndLocale,
  ...ndsLocale,
  ...neLocale,
  ...nlLocale,
  ...nmgLocale,
  ...nnLocale,
  ...nnhLocale,
  ...noLocale,
  ...nqoLocale,
  ...nrLocale,
  ...nsoLocale,
  ...nusLocale,
  ...nyLocale,
  ...nynLocale,
  ...omLocale,
  ...orLocale,
  ...osLocale,
  ...paLocale,
  ...papLocale,
  ...plLocale,
  ...prgLocale,
  ...psLocale,
  ...ptLocale,
  ...quLocale,
  ...rmLocale,
  ...rnLocale,
  ...roLocale,
  ...rofLocale,
  ...ruLocale,
  ...rwLocale,
  ...rwkLocale,
  ...sahLocale,
  ...saqLocale,
  ...sbpLocale,
  ...sdhLocale,
  ...seLocale,
  ...sehLocale,
  ...sesLocale,
  ...sgLocale,
  ...shLocale,
  ...shiLocale,
  ...siLocale,
  ...skLocale,
  ...slLocale,
  ...smaLocale,
  ...smiLocale,
  ...smjLocale,
  ...smnLocale,
  ...smsLocale,
  ...snLocale,
  ...soLocale,
  ...sqLocale,
  ...srLocale,
  ...ssLocale,
  ...ssyLocale,
  ...stLocale,
  ...svLocale,
  ...swLocale,
  ...syrLocale,
  ...taLocale,
  ...teLocale,
  ...teoLocale,
  ...thLocale,
  ...tiLocale,
  ...tigLocale,
  ...tkLocale,
  ...tlLocale,
  ...tnLocale,
  ...toLocale,
  ...trLocale,
  ...tsLocale,
  ...twqLocale,
  ...tzmLocale,
  ...ugLocale,
  ...ukLocale,
  ...urLocale,
  ...uzLocale,
  ...vaiLocale,
  ...veLocale,
  ...viLocale,
  ...voLocale,
  ...vunLocale,
  ...waLocale,
  ...waeLocale,
  ...woLocale,
  ...xhLocale,
  ...xogLocale,
  ...yavLocale,
  ...yiLocale,
  ...yoLocale,
  ...yueLocale,
  ...zghLocale,
  ...zhLocale,
  ...zuLocale,
]);

const mapStateToProps = ({ i18n: { locale, locales, translations } }) => ({
  locale,
  locales,
  translations,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadTranslations: load,
      loadLocales: loadLocales,
    },
    dispatch
  );

const LanguageProvider = ({
  locale,
  locales,
  translations,
  loadTranslations,
  children,
  loadLocales,
}) => {
  const _locale = locale || 'de';

  useEffect(() => {
    if (!locales || locales.length === 1) {
      loadLocales();
    }

    if (!translations[_locale]) {
      loadTranslations();
    }
  }, []);

  return translations && translations[_locale] ? (
    <IntlProvider locale={_locale} messages={translations[_locale]}>
      {React.Children.only(children)}
    </IntlProvider>
  ) : (
    <Loading />
  );
};

LanguageProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  locales: PropTypes.array.isRequired,
  translations: PropTypes.objectOf(PropTypes.object).isRequired,
  loadTranslations: PropTypes.func.isRequired,
  children: PropTypes.element.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageProvider);



// WEBPACK FOOTER //
// ./src/containers/LanguageProvider/index.js